import { useIntl } from 'react-intl';

import messages from './messages';
import { Wrapper } from './styles';

const PlanSubtext = () => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper>
			<p>{formatMessage(messages.message1)}</p>
			<p>{formatMessage(messages.message2)}</p>
		</Wrapper>
	);
};

export default PlanSubtext;
